import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { ServerLayoutPage } from '@/components/customisation/render/server-layout-page';
import { serverQuery } from '@/lib/server-queries';

export const Route = createFileRoute('/_app/server/$server/console')({ component: ConsolePage });

/**
 * The console page, laid out by the provider's server console layout (Customisation
 * Studio). The console and status alerts are required there, so they are always present.
 */
function ConsolePage() {
  const { server: id } = Route.useParams();
  const { data: server } = useSuspenseQuery(serverQuery(id));
  return <ServerLayoutPage server={server} surface="server-console" />;
}
